<template>
  <div
    ref="rs_iframe"
    class="rs-iframe"
  >
    <iframe
      style="border: 0;"
      :src="url"
      :title="title"
      :width="width"
      :height="height"
      @load="$emit('on-load-iframe')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsIframe',

  props: {
    title: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    /* sandbox: {
      type: String,
      default: '',
    }, */
  },
  data() {
    return {
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.rs-iframe {
  width: 100%;
  height: 100%;

  min-width: 300px;
  min-height: 300px;
  color: inherit;
}
</style>
